import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import { Box, Container } from "@mui/material";
import React, { useEffect, useState } from "react";
import BodyWrapper from "../utils/BodyWrapper";
import { useNavigate } from "react-router-dom";
import ListSponsors from "./AdminCrud/Sponsors/ListSponsors";
import ListPublicaciones from "./AdminCrud/Posts/ListPost";
import ListCategories from "./AdminCrud/Categories/ListCategories";
import ListProcedures from "./AdminCrud/Procedures/ListProcedures";
import ListDisciplines from "./AdminCrud/Discipline/ListDiscipline";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { API } from "../App";

/**
 *
 * @param {*} props
 * @returns
 */
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

/**
 *
 */
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

/**
 *
 * @param {*} index
 * @returns
 */
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function AdminTabPanel({ currentTab }) {
  const [value, setValue] = useState(0);
  const [lastSync, setLastSync] = useState({
    name: "",
    status: "",
    createdAt: "",
  });

  const getLastSynk = async () => {
    const lastSynkResponse = await fetch(`${API}/api/admin/comet/last`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage["tk"]}`,
      },
    })
      .then((res) => {
        if (res.status === 401) {
          localStorage.removeItem("tk");
          window.location.href = "/admin";
        } else {
        }
        return res.json();
      })
      .catch((err) => {
        console.log("error: ", err);
      });

    console.log("lastSync : ", lastSync);
    if (lastSynkResponse && lastSynkResponse.length > 0) {
      setLastSync(lastSynkResponse[0]);
    }
  };

  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(`/admin/panel/${newValue + 1}`);
  };

  const handleCometSync = async (e) => {
    try {
      const response = await fetch(`${API}/api/admin/comet/synchronyze`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage["tk"]}`,
        },
      }).then((res) => res.json());
      if (response.message) {
        alert(response.message);
      }
      getLastSynk();
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (currentTab) {
      setValue(Number(currentTab) - 1);
    }
    getLastSynk();
  }, []);

  return (
    <>
      <BodyWrapper>
        <Container component="main">
          <Box sx={{ width: "1024px" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <ul className="admintabpanel__tools">
                <li className="admintabpanel__toolItem">
                  <button
                    className="admintabpanel__toolBtn"
                    onClick={handleCometSync}
                  >
                    <PlayArrowIcon style={{ marginRight: "5px" }} />
                    COMET Data Sync - Ultima Actualizacion: Fecha:{" "}
                    {lastSync.createdAt} Estado: {lastSync.status}
                  </button>
                </li>
              </ul>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  style={{ color: "black", fontSize: "1.5rem" }}
                  label="Sponsors"
                  {...a11yProps(1)}
                />
                <Tab
                  style={{ color: "black", fontSize: "1.5rem" }}
                  label="Categorias"
                  {...a11yProps(2)}
                />
                <Tab
                  style={{ color: "black", fontSize: "1.5rem" }}
                  label="Publicaciones"
                  {...a11yProps(3)}
                />
                <Tab
                  style={{ color: "black", fontSize: "1.5rem" }}
                  label="Tramites"
                  {...a11yProps(4)}
                />
                <Tab
                  style={{ color: "black", fontSize: "1.5rem" }}
                  label="Tribunal de Disciplina"
                  {...a11yProps(5)}
                />
              </Tabs>
            </Box>
            {/* Sponsors */}
            <TabPanel value={value} index={0}>
              <ListSponsors />
            </TabPanel>
            {/* Categorias */}
            <TabPanel value={value} index={1}>
              <ListCategories />
            </TabPanel>
            {/* Publicaciones */}
            <TabPanel value={value} index={2}>
              <ListPublicaciones />
            </TabPanel>
            {/* Tramites */}
            <TabPanel value={value} index={3}>
              <ListProcedures />
            </TabPanel>
            {/* Tribunal de Disciplina */}
            <TabPanel value={value} index={4}>
              <ListDisciplines />
            </TabPanel>
          </Box>
        </Container>
      </BodyWrapper>
    </>
  );
}
export default AdminTabPanel;
